(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["communtiy"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__salvationStories1) { window.__salvationStories1(); return; }
  const roots = '[data-salvation-stories]';
  const rootOf = target => target instanceof Element ? target.closest(roots) : null;
  const cardsOf = root => Array.from(root.querySelectorAll('[data-story-card]'));
  function sync(root) {
    const track = root.querySelector('[data-story-track]'), cards = cardsOf(root);
    if (!track || !cards.length) return;
    let current = 0, distance = Infinity;
    cards.forEach((card, index) => { const delta = Math.abs(card.offsetLeft - track.scrollLeft); if (delta < distance) { current = index; distance = delta; } });
    root.dataset.storyIndex = String(current);
    root.querySelectorAll('[data-story-dot]').forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
    const previous = root.querySelector('[data-story-prev]'), next = root.querySelector('[data-story-next]');
    if (previous) previous.disabled = current === 0;
    if (next) next.disabled = current === cards.length - 1;
    const label = root.querySelector('[data-story-count-label]');
    if (label) label.textContent = `${String(current + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
  }
  function go(root, index) {
    const cards = cardsOf(root), track = root.querySelector('[data-story-track]');
    if (!track || !cards.length) return;
    const current = Math.min(cards.length - 1, Math.max(0, index));
    const reduced = root.dataset.motion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: cards[current].offsetLeft - 4, behavior: reduced ? 'auto' : 'smooth' });
  }
  function openImage(root, card) {
    const dialog = root.querySelector('[data-story-dialog]');
    if (!dialog || !card.dataset.storyFull) return;
    const image = document.createElement('img'); image.src = card.dataset.storyFull; image.alt = card.querySelector('.sstory__photo')?.alt || '';
    dialog.querySelector('[data-story-viewer-image]').replaceChildren(image);
    dialog.querySelector('[data-story-viewer-title]').textContent = card.querySelector('[data-story-author]')?.textContent || '';
    dialog.querySelector('[data-story-viewer-quote]').textContent = card.querySelector('[data-story-quote]')?.textContent.trim() || '';
    if (!dialog.open) dialog.showModal();
  }
  const boot = () => document.querySelectorAll(roots).forEach(sync);
  document.addEventListener('click', event => {
    const root = rootOf(event.target); if (!root) return;
    const target = event.target;
    const dot = target.closest('[data-story-dot]');
    if (dot) go(root, Number(dot.dataset.storyDot));
    if (target.closest('[data-story-prev]')) go(root, Number(root.dataset.storyIndex || 0) - 1);
    if (target.closest('[data-story-next]')) go(root, Number(root.dataset.storyIndex || 0) + 1);
    const image = target.closest('[data-story-open]');
    if (image) openImage(root, image.closest('[data-story-card]'));
    if (target.closest('[data-story-close]')) root.querySelector('[data-story-dialog]')?.close();
    if (target.matches('[data-story-dialog]')) {
      const box = target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) target.close();
    }
    if (target.closest('[data-story-product]')) {
      const candidates = Array.from(document.querySelectorAll('[data-salvation-v9],[data-salvation-root],product-info,[id^="MainProduct-"]'));
      const product = candidates.filter(node => node.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING).pop();
      if (product) {
        event.preventDefault();
        const reduced = root.dataset.motion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        product.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    }
  });
  const pending = new WeakMap();
  document.addEventListener('scroll', event => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-story-track]')) return;
    const root = rootOf(event.target); if (!root || pending.has(root)) return;
    pending.set(root, requestAnimationFrame(() => { pending.delete(root); sync(root); }));
  }, { capture: true, passive: true });
  document.addEventListener('keydown', event => {
    const root = rootOf(event.target); if (!root || !event.target.closest('[data-story-track]') || !window.matchMedia('(max-width: 749px)').matches) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); go(root, Number(root.dataset.storyIndex || 0) + (event.key === 'ArrowRight' ? 1 : -1)); }
    if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); go(root, event.key === 'Home' ? 0 : cardsOf(root).length - 1); }
  });
  let frame;
  window.addEventListener('resize', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(boot); }, { passive: true });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', event => {
    const root = rootOf(event.target), card = event.target instanceof Element ? event.target.closest('[data-story-card]') : null;
    if (root && card && window.matchMedia('(max-width: 749px)').matches) go(root, cardsOf(root).indexOf(card));
  });
  window.__salvationStories1 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparisonsalva"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__salvationCompare1) { window.__salvationCompare1(); return; }
  const update = input => {
    const frame = input.closest('[data-sc-compare]');
    const root = input.closest('[data-salvation-compare]');
    const value = Math.min(100, Math.max(0, Number(input.value)));
    frame.style.setProperty('--sc-split', `${value}%`);
    input.setAttribute('aria-valuetext', `${value}% ${input.dataset.valueText || 'of the Before image visible'}`);
    root.querySelectorAll('[data-sc-set]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.scSet) === value)));
  };
  const boot = () => document.querySelectorAll('[data-sc-range]').forEach(update);
  document.addEventListener('input', event => { if (event.target.matches('[data-sc-range]')) update(event.target); });
  document.addEventListener('change', event => { if (event.target.matches('[data-sc-range]')) update(event.target); });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const root = target?.closest('[data-salvation-compare]');
    if (!root) return;
    const reset = target.closest('[data-sc-reset]');
    const view = target.closest('[data-sc-set]');
    if (reset || view) {
      const input = root.querySelector('[data-sc-range]');
      input.value = view ? view.dataset.scSet : input.closest('[data-sc-compare]').dataset.start;
      update(input);
    }
    if (target.closest('[data-sc-product]')) {
      const candidates = Array.from(document.querySelectorAll('[data-salvation-v9],[data-salvation-root],product-info,[id^="MainProduct-"]'));
      const product = candidates.filter(node => node.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING).pop();
      if (product) {
        event.preventDefault();
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches || root.dataset.motion !== 'true';
        product.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    }
  });
  window.__salvationCompare1 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["details"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__salvationDetails1) { window.__salvationDetails1(); return; }
  const roots = '[data-salvation-details]';
  const rootOf = target => target instanceof Element ? target.closest(roots) : null;
  const reduced = root => root.dataset.motion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cardsOf = root => Array.from(root.querySelectorAll('[data-sd-card]'));
  function sync(root) {
    const track = root.querySelector('[data-sd-track]');
    const cards = cardsOf(root);
    if (!track || !cards.length) return;
    let active = 0, distance = Infinity;
    cards.forEach((card, index) => { const delta = Math.abs(card.offsetLeft - track.scrollLeft); if (delta < distance) { active = index; distance = delta; } });
    root.dataset.detailIndex = String(active);
    root.querySelectorAll('[data-sd-dot]').forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
    const previous = root.querySelector('[data-sd-prev]'), next = root.querySelector('[data-sd-next]');
    if (previous) previous.disabled = active === 0;
    if (next) next.disabled = active === cards.length - 1;
    const count = root.querySelector('[data-sd-counter]');
    if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
  }
  function go(root, index) {
    const cards = cardsOf(root), track = root.querySelector('[data-sd-track]');
    if (!cards.length || !track) return;
    const active = Math.max(0, Math.min(cards.length - 1, index));
    track.scrollTo({ left: cards[active].offsetLeft, behavior: reduced(root) ? 'auto' : 'smooth' });
  }
  function showViewer(root, index) {
    const cards = cardsOf(root).filter(card => card.dataset.sdFull);
    const dialog = root.querySelector('[data-sd-dialog]');
    if (!dialog || !cards.length) return;
    const active = (index + cards.length) % cards.length;
    const card = cards[active];
    root.dataset.viewerIndex = String(active);
    const image = document.createElement('img');
    image.src = card.dataset.sdFull;
    image.alt = card.querySelector('img')?.alt || card.querySelector('[data-sd-title]')?.textContent || '';
    dialog.querySelector('[data-sd-viewer-image]').replaceChildren(image);
    dialog.querySelector('[data-sd-viewer-title]').textContent = card.querySelector('[data-sd-title]')?.textContent || '';
    dialog.querySelector('[data-sd-viewer-copy]').textContent = card.querySelector('[data-sd-body]')?.textContent.trim() || '';
    dialog.querySelectorAll('[data-sd-viewer-prev],[data-sd-viewer-next]').forEach(button => { button.hidden = cards.length < 2; });
    if (!dialog.open) dialog.showModal();
  }
  const boot = () => document.querySelectorAll(roots).forEach(sync);
  document.addEventListener('click', event => {
    const root = rootOf(event.target); if (!root) return;
    const target = event.target;
    const dot = target.closest('[data-sd-dot]');
    if (dot) go(root, Number(dot.dataset.sdDot));
    if (target.closest('[data-sd-prev]')) go(root, Number(root.dataset.detailIndex || 0) - 1);
    if (target.closest('[data-sd-next]')) go(root, Number(root.dataset.detailIndex || 0) + 1);
    const open = target.closest('[data-sd-open]');
    if (open) {
      const cards = cardsOf(root).filter(card => card.dataset.sdFull);
      showViewer(root, cards.indexOf(open.closest('[data-sd-card]')));
    }
    if (target.closest('[data-sd-close]')) root.querySelector('[data-sd-dialog]')?.close();
    if (target.closest('[data-sd-viewer-prev]')) showViewer(root, Number(root.dataset.viewerIndex || 0) - 1);
    if (target.closest('[data-sd-viewer-next]')) showViewer(root, Number(root.dataset.viewerIndex || 0) + 1);
    if (target.matches('[data-sd-dialog]')) {
      const box = target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) target.close();
    }
    if (target.closest('[data-sd-product]')) {
      const candidates = Array.from(document.querySelectorAll('[data-salvation-v9],[data-salvation-root],product-info,[id^="MainProduct-"]'));
      const product = candidates.filter(node => node.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING).pop();
      if (product) { event.preventDefault(); product.scrollIntoView({ behavior: reduced(root) ? 'auto' : 'smooth', block: 'start' }); }
    }
  });
  const pending = new WeakMap();
  document.addEventListener('scroll', event => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-sd-track]')) return;
    const root = rootOf(event.target);
    if (!root || pending.has(root)) return;
    pending.set(root, requestAnimationFrame(() => { pending.delete(root); sync(root); }));
  }, { capture: true, passive: true });
  document.addEventListener('keydown', event => {
    const root = rootOf(event.target); if (!root) return;
    const dialog = root.querySelector('[data-sd-dialog]');
    if (dialog?.open) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); showViewer(root, Number(root.dataset.viewerIndex || 0) + (event.key === 'ArrowRight' ? 1 : -1));
      }
      return;
    }
    if (event.target.closest('[data-sd-track]') && window.matchMedia('(max-width: 749px)').matches) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); go(root, Number(root.dataset.detailIndex || 0) + (event.key === 'ArrowRight' ? 1 : -1)); }
      if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); go(root, event.key === 'Home' ? 0 : cardsOf(root).length - 1); }
    }
  });
  let frame;
  window.addEventListener('resize', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(boot); }, { passive: true });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', event => {
    const root = rootOf(event.target), card = event.target instanceof Element ? event.target.closest('[data-sd-card]') : null;
    if (root && card && window.matchMedia('(max-width: 749px)').matches) go(root, cardsOf(root).indexOf(card));
  });
  window.__salvationDetails1 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__salvationFit1) { window.__salvationFit1(); return; }
  const roots = '[data-salvation-fit]';
  const rootOf = target => target instanceof Element ? target.closest(roots) : null;
  function convert(raw, precision) {
    const clean = raw.trim();
    if (!clean) return '—';
    const match = clean.match(/^(\d+(?:[.,]\d+)?)(?:\s*[-–]\s*(\d+(?:[.,]\d+)?))?\s*(?:cm)?$/i);
    if (!match) return /\d/.test(clean) ? '—' : clean;
    const value = text => String(Number((Number(text.replace(',', '.')) / 2.54).toFixed(precision)));
    return match[2] ? `${value(match[1])}–${value(match[2])}` : value(match[1]);
  }
  function units(root, unit) {
    const chosen = unit === 'in' ? 'in' : 'cm';
    const precision = Math.min(2, Math.max(0, Number(root.dataset.precision) || 0));
    root.dataset.unit = chosen;
    root.querySelectorAll('[data-fit-cm]').forEach(cell => {
      const raw = cell.dataset.fitCm || '';
      cell.textContent = chosen === 'in' ? convert(raw, precision) : raw.trim() || '—';
    });
    root.querySelectorAll('[data-fit-unit-label]').forEach(label => { label.textContent = chosen; });
    root.querySelectorAll('[data-fit-unit]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.fitUnit === chosen)); });
  }
  const boot = () => document.querySelectorAll(roots).forEach(root => units(root, root.dataset.unit));
  document.addEventListener('click', event => {
    const root = rootOf(event.target); if (!root) return;
    const button = event.target.closest('[data-fit-unit]');
    if (button) units(root, button.dataset.fitUnit);
    const link = event.target.closest('[data-fit-product]');
    if (link) {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !location.pathname.endsWith(url.pathname)) return;
      const candidates = Array.from(document.querySelectorAll('[data-salvation-v9],[data-salvation-root],product-info,[id^="MainProduct-"]'));
      const product = candidates.filter(node => node.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING).pop();
      if (product) {
        event.preventDefault();
        const reduced = root.dataset.motion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        product.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    }
  });
  window.__salvationFit1 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__salvationEnglish13) { window.__salvationEnglish13(); return; }
  const busy = new WeakSet();
  const selector = '[data-salvation-v13]';
  const rootOf = target => target instanceof Element ? target.closest(selector) : null;
  const url = root => (root.dataset.root || '/').replace(/\/?$/, '/');
  const money = (root, value) => {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'EUR' }).format(Number(value || 0) / 100); }
    catch { return (Number(value || 0) / 100).toFixed(2); }
  };
  const feedback = (root, text) => {
    const node = root.querySelector('[data-feedback]');
    if (node) { node.textContent = text; node.hidden = !text; }
  };
  const selected = root => root.querySelector('[data-offer]:has(input[type="radio"]:checked)') || root.querySelector('[data-offer]');
  const picks = card => Array.from(card?.querySelectorAll('[data-variant-picker]') || []).map(select => select.selectedOptions[0]);
  const basePrice = card => picks(card).reduce((sum, option) => sum + Number(option?.dataset.price || 0), 0);
  const price = (root, card) => {
    const base = basePrice(card);
    if (card?.dataset.priceMode === 'fixed_total') {
      const total = Number(card.dataset.fixedPrice);
      if (Number.isSafeInteger(total) && total >= 0) return Math.min(base, total);
    }
    if (card?.dataset.priceMode === 'fixed_amount') {
      const amount = Number(card.dataset.fixedAmount);
      if (Number.isSafeInteger(amount) && amount >= 0) return Math.max(0, base - amount);
    }
    return picks(card).reduce((sum, option) => sum + Math.round(Number(option?.dataset.price || 0) * (100 - Number(card.dataset.discount || 0)) / 100), 0);
  };
  const valid = card => picks(card).length > 0 && picks(card).every(option => option && !option.disabled && option.value);
  function refresh(root) {
    const active = selected(root);
    if (!active) return;
    root.querySelectorAll('[data-offer]').forEach(card => {
      const isActive = card === active;
      card.dataset.selected = String(isActive);
      const rows = card.querySelector('[data-server-rows]');
      if (rows) rows.disabled = !isActive;
      const output = card.querySelector('[data-offer-price]');
      if (output) output.textContent = money(root, price(root, card));
      const compare = card.querySelector('[data-offer-compare]');
      if (compare) {
        const amount = picks(card).reduce((sum, option) => sum + Math.max(Number(option?.dataset.price || 0), Number(option?.dataset.compare || 0)), 0);
        compare.textContent = money(root, amount); compare.hidden = amount <= price(root, card);
      }
    });
    const total = price(root, active);
    root.querySelectorAll('[data-main-price],[data-atc-price],[data-sticky-price]').forEach(node => { node.textContent = money(root, total); });
    const mainCompare = root.querySelector('[data-main-compare]');
    const activeCompare = active.querySelector('[data-offer-compare]');
    if (mainCompare && activeCompare) { mainCompare.textContent = activeCompare.textContent; mainCompare.hidden = activeCompare.hidden; }
    const summary = root.querySelector('[data-selection-summary]');
    if (summary) summary.textContent = `${picks(active).length} selected`;
    const note = root.querySelector('[data-discount-note]');
    if (note) note.hidden = price(root, active) >= basePrice(active);
    root.querySelectorAll('[data-atc],[data-buy-now],[data-sticky-atc]').forEach(button => { button.disabled = busy.has(root) || !valid(active); });
    const label = root.querySelector('[data-atc-label]');
    if (label) label.textContent = busy.has(root) ? root.dataset.adding : valid(active) ? root.dataset.originalAdd : root.dataset.soldOut;
    root.setAttribute('data-ready', '');
  }
  function gallery(root, index) {
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    if (!slides.length) return;
    const active = (index + slides.length) % slides.length;
    root.dataset.galleryIndex = String(active);
    slides.forEach((slide, i) => { slide.hidden = i !== active; slide.classList.toggle('svb__slide--changed', i === active); });
    root.querySelectorAll('[data-thumb]').forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === active)));
    const count = root.querySelector('[data-gallery-count]');
    if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
  }
  function boot() {
    document.querySelectorAll(selector).forEach(root => {
      if (!root.dataset.originalAdd) root.dataset.originalAdd = root.querySelector('[data-atc-label]')?.textContent.trim() || 'Add to cart';
      refresh(root);
      if (!root.dataset.galleryIndex) gallery(root, 0);
    });
  }
  const pendingDiscounts = new WeakMap();
  const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const selectionKey = card => `${card?.dataset.blockId || ''}:${picks(card).map(option => option?.value || '').join(',')}`;
  const normalizeCode = value => String(value || '').trim().toUpperCase();
  const uniqueCodes = codes => Array.from(new Set(codes.map(normalizeCode).filter(Boolean)));
  function cartCodes(cart) {
    const codes = (cart.discount_codes || []).map(entry => entry.code);
    const applications = [...(cart.cart_level_discount_applications || [])];
    for (const item of cart.items || []) for (const allocation of item.line_level_discount_allocations || []) applications.push(allocation.discount_application);
    for (const application of applications) if (application?.type === 'discount_code') codes.push(application.title);
    return uniqueCodes(codes);
  }
  function productLines(root, cart) {
    const ids = new Set(Array.from(root.querySelectorAll('[data-variant-picker] option')).map(option => option.value));
    return (cart.items || []).filter(item => Number(item.product_id) === Number(root.dataset.productId) || ids.has(String(item.variant_id || item.id)));
  }
  function bestDeal(root, cart) {
    const quantity = productLines(root, cart).reduce((total, item) => total + Number(item.quantity || 0), 0);
    return Array.from(root.querySelectorAll('[data-offer]')).filter(card => Number(card.dataset.quantity) <= quantity && (price(root, card) < basePrice(card) || normalizeCode(card.dataset.discountCode))).sort((a, b) => Number(b.dataset.quantity) - Number(a.dataset.quantity) || (basePrice(b) - price(root, b)) - (basePrice(a) - price(root, a)))[0] || null;
  }
  function discountVerified(root, cart, deal) {
    if (!deal) return true;
    const code = normalizeCode(deal.dataset.discountCode), percent = Number(deal.dataset.discount || 0);
    if (code) {
      const declared = (cart.discount_codes || []).find(entry => normalizeCode(entry.code) === code);
      if (declared && !declared.applicable) return false;
      if (!declared && !cartCodes(cart).includes(code)) return false;
    }
    const lines = productLines(root, cart);
    if (!lines.length || lines.some(item => typeof (item.final_line_price ?? item.line_price) !== 'number')) return false;
    const original = lines.reduce((total, item) => total + Number(item.original_line_price ?? Number(item.original_price ?? item.price ?? 0) * Number(item.quantity || 0)), 0);
    const final = lines.reduce((total, item) => total + Number(item.final_line_price ?? item.line_price ?? 0), 0);
    const tolerance = lines.reduce((total, item) => total + Number(item.quantity || 0), 0);
    if (original <= 0 || final >= original) return false;
    if (deal.dataset.priceMode === 'fixed_total' || deal.dataset.priceMode === 'fixed_amount') {
      const count = Math.max(1, Number(deal.dataset.quantity || picks(deal).length));
      const quantity = lines.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      const saving = Math.max(0, basePrice(deal) - price(root, deal));
      const expected = deal.dataset.priceMode === 'fixed_total' ? Math.min(original, Math.round(price(root, deal) * quantity / count)) : Math.max(0, Math.round(original - saving * quantity / count));
      return final <= expected;
    }
    return !percent || final <= Math.round(original * (100 - percent) / 100) + tolerance;
  }
  async function readCart(root) {
    const response = await fetch(`${url(root)}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(root.dataset.cartError || 'Could not load your cart.');
    const cart = await response.json();
    if (!Array.isArray(cart.items) || typeof cart.total_price !== 'number') throw new Error(root.dataset.cartError || 'Could not load your cart.');
    return cart;
  }
  async function reconcileDiscount(root, cart, sections = []) {
    const deal = bestDeal(root, cart), code = normalizeCode(deal?.dataset.discountCode);
    const productId = root.dataset.productId;
    const relatedRoots = Array.from(document.querySelectorAll(selector)).filter(node => node.dataset.productId === productId);
    const managed = uniqueCodes(relatedRoots.flatMap(node => Array.from(node.querySelectorAll('[data-offer]')).map(card => card.dataset.discountCode)));
    const existing = cartCodes(cart), preserved = existing.filter(item => !managed.includes(item));
    const requested = uniqueCodes([...preserved, code]);
    const changed = existing.slice().sort().join(',') !== requested.slice().sort().join(',');
    let updatedCart = false;
    if (code || changed) {
      const payload = { discount: requested.join(',') };
      if (sections.length) { payload.sections = sections; payload.sections_url = location.pathname + location.search; }
      const response = await fetch(`${url(root)}cart/update.js`, { method: 'POST', headers, body: JSON.stringify(payload) });
      const updated = await response.json();
      if (!response.ok || updated.status) throw new Error(updated.description || updated.message || root.dataset.bundleError);
      if (!Array.isArray(updated.items) || typeof updated.total_price !== 'number') throw new Error(root.dataset.bundleError);
      cart = updated; updatedCart = true;
    }
    return { cart, deal, updatedCart, verified: discountVerified(root, cart, deal) };
  }
  function markDiscount(root, verified) {
    if (verified) { delete root.dataset.bundleWarning; pendingDiscounts.delete(root); }
    else root.dataset.bundleWarning = root.dataset.bundleError || 'Your items are in the cart, but the bundle discount could not be applied. Please retry or check the cart total before checkout.';
  }
  function querySafe(scope, value) {
    if (!value) return null;
    try { return scope.querySelector(value); } catch { return null; }
  }
  function themeDrawer(root) {
    const custom = querySafe(document, root.dataset.themeDrawerSelector);
    const node = custom || document.querySelector('cart-drawer,#CartDrawer,[data-cart-drawer],.cart-drawer');
    return node?.closest('cart-drawer') || node;
  }
  function drawerPlan(root, drawer) {
    const wrapper = drawer?.closest('[id^="shopify-section-"]');
    const wrapperId = wrapper?.id.replace(/^shopify-section-/, '');
    const owner = wrapperId && !/(?:^|__)main-cart(?:-|$)/i.test(wrapperId) ? wrapperId : 'cart-drawer';
    return { keys: Array.from(new Set([owner, 'cart-drawer', 'cart-icon-bubble'])), owner };
  }
  function drawerFragment(root, html, drawer) {
    if (typeof html !== 'string' || !html.trim()) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const source = querySafe(doc, root.dataset.themeDrawerSelector) || doc.querySelector('cart-drawer') || (drawer?.id ? doc.getElementById(drawer.id) : null) || doc.getElementById('CartDrawer');
    if (!source || source.querySelector('#main-cart-items,#main-cart-footer,[data-main-cart-items]')) return null;
    if (!source.matches('cart-drawer,#CartDrawer,[data-cart-drawer]') && !source.querySelector('cart-drawer-items,#CartDrawer-Form,#CartDrawer-CartItems')) return null;
    return { source, doc, html: `<div id="shopify-section-cart-drawer" class="shopify-section">${source.outerHTML}</div>` };
  }
  async function freshShrineCart(root, drawer) {
    const plan = drawerPlan(root, drawer);
    let cart = null, sections = {};
    try {
      const response = await fetch(`${url(root)}cart/update.js`, { method: 'POST', headers, body: JSON.stringify({ updates: {}, sections: plan.keys, sections_url: location.pathname + location.search }) });
      const result = await response.json();
      if (response.ok && !result.status && Array.isArray(result.items)) { cart = result; sections = result.sections || {}; }
    } catch {}
    const keys = Array.from(new Set([plan.owner, 'cart-drawer']));
    let fragment = keys.map(key => drawerFragment(root, sections[key], drawer)).find(Boolean);
    if (!fragment) {
      try {
        const target = new URL(location.href); target.hash = ''; target.searchParams.delete('sections'); target.searchParams.delete('section_id'); target.searchParams.set('_svb_drawer', String(Date.now()));
        const response = await fetch(target, { headers: { Accept: 'text/html' }, cache: 'no-store' });
        if (response.ok) fragment = drawerFragment(root, await response.text(), drawer);
      } catch {}
    }
    if (!cart) cart = await readCart(root);
    return { cart, sections, fragment };
  }
  function patchShrineDrawer(root, drawer, fragment) {
    if (!drawer || !fragment) return false;
    const source = fragment.source;
    const currentPanel = querySafe(drawer, root.dataset.themeDrawerContent) || drawer.querySelector('.drawer__inner');
    const freshPanel = querySafe(source, root.dataset.themeDrawerContent) || source.querySelector('.drawer__inner');
    if (currentPanel && freshPanel) {
      currentPanel.innerHTML = freshPanel.innerHTML;
      currentPanel.classList.remove('is-empty');
      currentPanel.hidden = false;
    } else {
      const currentCart = drawer.id === 'CartDrawer' ? drawer : drawer.querySelector('#CartDrawer');
      const freshCart = source.id === 'CartDrawer' ? source : source.querySelector('#CartDrawer');
      if (!currentCart || !freshCart) return false;
      currentCart.innerHTML = freshCart.innerHTML;
    }
    drawer.classList.remove('is-empty'); drawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
    return true;
  }
  function updateShrineCounter(root, cart, sections, fragment) {
    const bubble = document.getElementById('cart-icon-bubble');
    let replacement = null;
    if (typeof sections['cart-icon-bubble'] === 'string') replacement = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').getElementById('cart-icon-bubble');
    if (!replacement) replacement = fragment?.doc.getElementById('cart-icon-bubble');
    if (bubble && replacement) bubble.innerHTML = replacement.innerHTML;
    document.querySelectorAll('[data-cart-count],#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').forEach(node => { node.textContent = String(cart.item_count); });
  }
  async function openThemeDrawer(root, drawer) {
    const button = root.querySelector('[data-atc]');
    try { drawer?.setActiveElement?.(button); } catch {}
    if (typeof drawer?.open === 'function') { try { await drawer.open(button); return true; } catch {} }
    if (typeof drawer?.show === 'function') { try { await drawer.show(); return true; } catch {} }
    if (drawer instanceof HTMLDialogElement) { if (!drawer.open) drawer.showModal(); return true; }
    if (drawer instanceof HTMLDetailsElement) { drawer.open = true; return true; }
    const triggerSelectors = root.dataset.themeCartTrigger || '#cart-icon-bubble,[aria-controls="CartDrawer"],[data-cart-toggle],[data-cart-drawer-open]';
    let triggers = [];
    try { triggers = Array.from(document.querySelectorAll(triggerSelectors)); } catch {}
    const trigger = triggers.find(node => node !== button && !root.contains(node) && !drawer?.contains(node));
    if (trigger) {
      const preventNavigation = event => event.preventDefault();
      trigger.addEventListener('click', preventNavigation, { capture: true, once: true });
      trigger.click();
      trigger.removeEventListener('click', preventNavigation, { capture: true });
      return true;
    }
    return false;
  }
  async function refreshThemeDrawer(root) {
    const drawer = themeDrawer(root);
    if (!drawer) return false;
    const fresh = await freshShrineCart(root, drawer);
    if (!fresh.fragment) return false;
    const sections = { 'cart-drawer': fresh.fragment.html };
    const bubbleHTML = fresh.sections['cart-icon-bubble'];
    if (typeof bubbleHTML === 'string' && !new DOMParser().parseFromString(bubbleHTML, 'text/html').querySelector('#main-cart-items,#main-cart-footer,cart-drawer,#CartDrawer')) sections['cart-icon-bubble'] = bubbleHTML;
    let rendered = false;
    if (typeof drawer.renderContents === 'function' && sections['cart-icon-bubble']) {
      try {
        drawer.setActiveElement?.(root.querySelector('[data-atc]'));
        drawer.classList.remove('is-empty');
        await drawer.renderContents({ ...fresh.cart, id: picks(selected(root))[0]?.value, sections });
        rendered = true;
      } catch {}
    }
    if (!rendered) rendered = patchShrineDrawer(root, drawer, fresh.fragment);
    if (!rendered) return false;
    updateShrineCounter(root, fresh.cart, fresh.sections, fresh.fragment);
    return await openThemeDrawer(root, drawer);
  }
  function renderDiscountStatus(root) {
    const discountButton = root.querySelector('[data-retry-bundle-discount]'), cartButton = root.querySelector('[data-retry-theme-cart]');
    if (discountButton) { discountButton.hidden = !root.dataset.bundleWarning; discountButton.disabled = busy.has(root); }
    if (cartButton) { cartButton.hidden = !root.dataset.drawerWarning; cartButton.disabled = busy.has(root); }
  }
  function resultFeedback(root, fallback) {
    feedback(root, [root.dataset.bundleWarning, root.dataset.drawerWarning].filter(Boolean).join(' ') || fallback);
    renderDiscountStatus(root);
  }
  async function syncAndOpen(root, cart, signature, verified, seed = {}) {
    let ready = false;
    try { ready = await refreshThemeDrawer(root, cart, seed); } catch {}
    if (ready) delete root.dataset.drawerWarning;
    else root.dataset.drawerWarning = root.dataset.drawerError || 'Your items are in the cart, but your theme drawer could not be refreshed. Please try Refresh cart.';
    if (verified && ready) pendingDiscounts.delete(root);
    else pendingDiscounts.set(root, { signature });
    return ready;
  }
  async function retryDiscount(root, checkout = false) {
    if (busy.has(root)) return;
    const signature = pendingDiscounts.get(root)?.signature || selectionKey(selected(root));
    busy.add(root); refresh(root); renderDiscountStatus(root);
    let cart = null;
    try {
      const outcome = await reconcileDiscount(root, await readCart(root));
      cart = await readCart(root);
      const verified = discountVerified(root, cart, bestDeal(root, cart));
      markDiscount(root, verified);
      if (checkout && verified) { location.assign(`${url(root)}checkout`); return; }
      await syncAndOpen(root, cart, signature, verified, outcome.cart.sections || {});
      resultFeedback(root, verified ? root.dataset.bundleApplied || 'Bundle discount applied.' : '');
    } catch {
      root.dataset.bundleWarning = root.dataset.bundleError || 'The bundle discount could not be applied. Your items are already in the cart.';
      try { cart = await readCart(root); await syncAndOpen(root, cart, signature, false); } catch { root.dataset.drawerWarning = root.dataset.drawerError; }
      pendingDiscounts.set(root, { signature }); resultFeedback(root, '');
    } finally { busy.delete(root); refresh(root); renderDiscountStatus(root); }
  }
  async function add(root, checkout) {
    if (busy.has(root)) return;
    if (!root.dataset.originalAdd) boot();
    const card = selected(root), signature = selectionKey(card);
    if (!valid(card)) { feedback(root, root.dataset.soldOut || 'Please select an available variant.'); return; }
    if (pendingDiscounts.get(root)?.signature === signature) { await retryDiscount(root, checkout); return; }
    busy.add(root); refresh(root); feedback(root, ''); renderDiscountStatus(root);
    delete root.dataset.bundleWarning; delete root.dataset.drawerWarning;
    let added = false;
    try {
      const grouped = new Map();
      picks(card).forEach(option => grouped.set(option.value, (grouped.get(option.value) || 0) + 1));
      const items = Array.from(grouped, ([id, quantity]) => ({ id: Number(id), quantity }));
      const plan = drawerPlan(root, themeDrawer(root));
      const response = await fetch(`${url(root)}cart/add.js`, { method: 'POST', headers, body: JSON.stringify({ items, sections: plan.keys, sections_url: location.pathname + location.search }) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || root.dataset.error || 'Could not add this selection.');
      added = true; pendingDiscounts.set(root, { signature });
      const outcome = await reconcileDiscount(root, await readCart(root), plan.keys);
      const cart = await readCart(root), verified = discountVerified(root, cart, bestDeal(root, cart));
      markDiscount(root, verified);
      if (checkout && verified) { location.assign(`${url(root)}checkout`); return; }
      await syncAndOpen(root, cart, signature, verified, outcome.updatedCart ? outcome.cart.sections : result.sections);
      resultFeedback(root, root.dataset.success || 'Added to your cart.');
    } catch (error) {
      if (added) {
        root.dataset.bundleWarning = root.dataset.bundleError || 'The bundle discount could not be applied. Your items are already in the cart.';
        try { const cart = await readCart(root); await syncAndOpen(root, cart, signature, false); } catch { root.dataset.drawerWarning = root.dataset.drawerError; }
        pendingDiscounts.set(root, { signature }); resultFeedback(root, '');
      } else feedback(root, error.message || root.dataset.error || 'Could not add this selection.');
    } finally { busy.delete(root); refresh(root); renderDiscountStatus(root); }
  }
  document.addEventListener('submit', event => {
    const root = rootOf(event.target);
    if (!root || !event.target.matches('.svb__form')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    add(root, event.submitter?.matches('[data-buy-now]'));
  }, true);
  document.addEventListener('change', event => {
    const root = rootOf(event.target); if (!root) return;
    if (event.target.matches('.svb__offer-heading>input,[data-variant-picker]')) {
      refresh(root); feedback(root, '');
      const id = event.target.selectedOptions?.[0]?.dataset.imageId;
      if (id) { const index = Array.from(root.querySelectorAll('[data-slide]')).findIndex(slide => slide.dataset.imageId === id); if (index >= 0) gallery(root, index); }
    }
  }, true);
  document.addEventListener('click', async event => {
    const root = rootOf(event.target); if (!root) return;
    const target = event.target;
    const thumb = target.closest('[data-thumb]');
    if (thumb) { event.preventDefault(); gallery(root, Number(thumb.dataset.thumb)); }
    if (target.closest('[data-prev]')) gallery(root, Number(root.dataset.galleryIndex || 0) - 1);
    if (target.closest('[data-next]')) gallery(root, Number(root.dataset.galleryIndex || 0) + 1);
    if (target.closest('[data-sticky-atc]')) { event.preventDefault(); add(root, false); }
    const close = target.closest('[data-close]'); if (close) close.closest('dialog')?.close();
    if (target.closest('[data-size-guide]')) root.querySelector('[data-size-dialog]')?.showModal();
    if (target.closest('[data-retry-bundle-discount],[data-retry-theme-cart]')) { event.preventDefault(); await retryDiscount(root); }
    if (target.closest('[data-zoom]')) {
      const slide = root.querySelectorAll('[data-slide]')[Number(root.dataset.galleryIndex || 0)];
      const image = slide?.querySelector('img'); const dialog = root.querySelector('[data-lightbox]');
      if (image && dialog) { dialog.querySelector('[data-zoom-content]').replaceChildren(image.cloneNode()); dialog.showModal(); }
    }
    const copy = target.closest('[data-copy-code]');
    if (copy) {
      try { await navigator.clipboard.writeText(copy.dataset.copyCode); copy.querySelector('[data-copy-label]').textContent = copy.dataset.copied || 'Copied ✓'; }
      catch { feedback(root, `${copy.dataset.fallback || 'Copy this code:'} ${copy.dataset.copyCode}`); }
    }
    if (target.matches('dialog')) { const box=target.getBoundingClientRect(); if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)target.close(); }
  }, true);
  let touch = null;
  document.addEventListener('touchstart', event => { const root=rootOf(event.target); if(root && event.target.closest('[data-slides]')) touch={root,x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}; }, {passive:true});
  document.addEventListener('touchend', event => { if(!touch)return;const dx=event.changedTouches[0].clientX-touch.x,dy=event.changedTouches[0].clientY-touch.y;if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))gallery(touch.root,Number(touch.root.dataset.galleryIndex||0)+(dx<0?1:-1));touch=null; }, {passive:true});
  let frame;
  window.addEventListener('scroll', () => { if(frame)return;frame=requestAnimationFrame(()=>{frame=null;document.querySelectorAll(selector).forEach(root=>{const bar=root.querySelector('[data-sticky-bar]'),button=root.querySelector('[data-atc]');if(bar&&button)bar.hidden=button.getBoundingClientRect().bottom>=0||root.dataset.sticky!=='true';});}); }, {passive:true});
  window.__salvationEnglish13 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  document.addEventListener('shopify:section:load', boot);
})();

(() => {
  if (window.__salvationBundleSwatches4) { window.__salvationBundleSwatches4(); return; }
  const rowStates = new WeakMap();
  const rootSelector = '[data-salvation-v13]';
  const rootOf = target => target instanceof Element ? target.closest(rootSelector) : null;
  function sync(row) {
    const state = rowStates.get(row);
    if (!state) return;
    const current = state.variants.find(variant => variant.node.value === state.native.value);
    if (!current) return;
    const soldOut = rootOf(row)?.dataset.soldOut || 'Sold out';
    row.querySelectorAll('[data-bundle-swatch]').forEach(button => {
      const index = Number(button.dataset.optionIndex), value = button.dataset.value;
      const available = state.variants.some(variant => variant.available && variant.values[index] === value);
      button.disabled = !available;
      button.setAttribute('aria-disabled', String(!available));
      button.setAttribute('aria-pressed', String(current.values[index] === value));
      button.title = `${button.dataset.colorLabel}${available ? '' : ` — ${soldOut}`}`;
      button.setAttribute('aria-label', button.title);
    });
    row.querySelectorAll('[data-bundle-option]').forEach(select => {
      const index = Number(select.dataset.optionIndex);
      Array.from(select.options).forEach(option => {
        const available = state.variants.some(variant => variant.available && variant.values[index] === option.value && current.values.every((value, position) => position === index || variant.values[position] === value));
        option.disabled = !available;
        option.textContent = `${option.dataset.baseLabel}${available ? '' : ` — ${soldOut}`}`;
      });
      select.value = current.values[index];
    });
    const caption = row.querySelector('[data-bundle-color-name]');
    if (caption) caption.textContent = row.querySelector('[data-bundle-swatch][aria-pressed="true"]')?.dataset.colorLabel || '';
  }
  function choose(row, index, value) {
    const state = rowStates.get(row);
    if (!state) return;
    const current = state.variants.find(variant => variant.node.value === state.native.value);
    if (!current) return;
    const wanted = current.values.map((item, position) => position === index ? value : item);
    let next = state.variants.find(variant => variant.available && wanted.every((item, position) => variant.values[position] === item));
    if (!next) {
      const isColour = Array.from(row.querySelectorAll('[data-bundle-swatch]')).some(button => Number(button.dataset.optionIndex) === index);
      if (isColour) {
        let score = -1;
        state.variants.forEach(variant => {
          if (!variant.available || variant.values[index] !== value) return;
          const matches = wanted.reduce((total, item, position) => total + Number(position !== index && variant.values[position] === item), 0);
          if (matches > score) { next = variant; score = matches; }
        });
      }
    }
    if (!next) { sync(row); return; }
    state.native.value = next.node.value;
    sync(row);
    state.native.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function boot() {
    document.querySelectorAll(`${rootSelector} [data-bundle-options]`).forEach(controls => {
      const row = controls.closest('.svb__item');
      if (rowStates.has(row)) { sync(row); return; }
      const native = row.querySelector('[data-variant-picker]');
      if (!native) return;
      let variants;
      try { variants = Array.from(native.options).map(node => ({ node, values: JSON.parse(node.dataset.options), available: !node.disabled })); }
      catch { return; }
      const count = Number(controls.dataset.optionCount);
      if (!count || !variants.length || variants.some(variant => !Array.isArray(variant.values) || variant.values.length !== count)) return;
      rowStates.set(row, { native, variants });
      sync(row);
      controls.hidden = false;
      row.dataset.swatchReady = 'true';
    });
  }
  document.addEventListener('click', event => {
    const root = rootOf(event.target);
    if (!root) return;
    const button = event.target.closest('[data-bundle-swatch]');
    if (!button || button.matches(':disabled')) return;
    event.preventDefault();
    choose(button.closest('.svb__item'), Number(button.dataset.optionIndex), button.dataset.value);
  });
  document.addEventListener('change', event => {
    if (!rootOf(event.target)) return;
    const target = event.target;
    if (target.matches('[data-bundle-option]')) choose(target.closest('.svb__item'), Number(target.dataset.optionIndex), target.value);
    if (target.matches('[data-variant-picker]')) sync(target.closest('.svb__item'));
  });
  window.__salvationBundleSwatches4 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shades"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__salvationShades1) { window.__salvationShades1(); return; }
  const roots = '[data-salvation-shades]';
  const rootOf = target => target instanceof Element ? target.closest(roots) : null;
  const panels = root => Array.from(root.querySelectorAll('[data-shade-panel]'));
  function choose(root, index, focus = false) {
    const looks = panels(root);
    if (!looks.length) return;
    const active = Math.max(0, Math.min(looks.length - 1, index));
    const previous = Number(root.dataset.shadeIndex || 0);
    root.dataset.shadeIndex = String(active);
    looks.forEach((panel, i) => {
      panel.hidden = i !== active;
      panel.classList.toggle('is-changing', i === active && previous !== active);
    });
    root.querySelectorAll('[data-shade-tab]').forEach((tab, i) => {
      tab.setAttribute('aria-selected', String(i === active));
      tab.tabIndex = i === active ? 0 : -1;
      if (focus && i === active) tab.focus({ preventScroll: true });
    });
    const look = looks[active];
    root.style.setProperty('--sh-tint', look.dataset.shadeTint);
    const name = root.querySelector('[data-shade-name-output]'), story = root.querySelector('[data-shade-story-output]');
    if (name) name.textContent = look.dataset.shadeName;
    if (story) story.textContent = look.dataset.shadeStory;
    const count = root.querySelector('[data-shade-count]');
    if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(looks.length).padStart(2, '0')}`;
    const cta = root.querySelector('[data-shade-cta]');
    if (cta) { cta.href = look.dataset.shadeLink; cta.dataset.shadeVariant = look.dataset.shadeVariant; }
  }
  function boot() {
    document.querySelectorAll(roots).forEach(root => {
      const visible = panels(root).findIndex(panel => !panel.hidden);
      choose(root, visible < 0 ? 0 : visible);
    });
  }
  function openImage(root, source, alt, title) {
    const dialog = root.querySelector('[data-shade-dialog]');
    if (!dialog || !source) return;
    const image = document.createElement('img'); image.src = source; image.alt = alt || title || '';
    dialog.querySelector('[data-shade-viewer-image]').replaceChildren(image);
    dialog.querySelector('[data-shade-viewer-title]').textContent = title || '';
    if (!dialog.open) dialog.showModal();
  }
  document.addEventListener('click', event => {
    const root = rootOf(event.target); if (!root) return;
    const target = event.target;
    const tab = target.closest('[data-shade-tab]');
    if (tab) choose(root, Number(tab.dataset.shadeTab));
    const zoom = target.closest('[data-shade-zoom]');
    if (zoom) {
      const look = zoom.closest('[data-shade-panel]');
      openImage(root, look.dataset.shadeFull, look.querySelector('img')?.alt, look.dataset.shadeName);
    }
    const detail = target.closest('[data-shade-detail]');
    if (detail) {
      const look = detail.closest('[data-shade-panel]');
      openImage(root, detail.dataset.shadeDetailUrl, detail.querySelector('img')?.alt, look.dataset.shadeName);
    }
    if (target.closest('[data-shade-close]')) root.querySelector('[data-shade-dialog]')?.close();
    if (target.matches('[data-shade-dialog]')) {
      const box = target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) target.close();
    }
    const cta = target.closest('[data-shade-cta]');
    if (cta) {
      const look = panels(root)[Number(root.dataset.shadeIndex || 0)];
      if (look?.dataset.shadeCustomLink === 'true') return;
      const link = new URL(cta.href, location.href);
      if (link.origin !== location.origin || !location.pathname.endsWith(link.pathname)) return;
      const candidates = Array.from(document.querySelectorAll('[data-salvation-v9],[data-salvation-root],product-info,[id^="MainProduct-"]'));
      const product = candidates.filter(node => node.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING).pop();
      if (!product) return;
      const variant = cta.dataset.shadeVariant;
      let picker;
      if (variant) {
        const active = product.querySelector('[data-offer]:has(input[type="radio"]:checked)');
        picker = active?.querySelector('[data-variant-picker]') || product.querySelector('select[name="id"]');
        if (!picker || !Array.from(picker.options).some(option => option.value === variant && !option.disabled)) return;
        picker.value = variant;
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      }
      event.preventDefault();
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches || root.dataset.motion !== 'true';
      product.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      if (picker) picker.focus({ preventScroll: true });
    }
  });
  document.addEventListener('keydown', event => {
    const root = rootOf(event.target); if (!root || !event.target.matches('[data-shade-tab]')) return;
    const current = Number(event.target.dataset.shadeTab), length = panels(root).length;
    let next;
    if (event.key === 'ArrowRight') next = (current + 1) % length;
    if (event.key === 'ArrowLeft') next = (current - 1 + length) % length;
    if (event.key === 'ArrowDown') next = (current + 2) % length;
    if (event.key === 'ArrowUp') next = (current - 2 + length) % length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = length - 1;
    if (next !== undefined) { event.preventDefault(); choose(root, next, true); }
  });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', event => {
    const root = rootOf(event.target);
    const panel = event.target instanceof Element ? event.target.closest('[data-shade-panel]') : null;
    if (root && panel) choose(root, Number(panel.dataset.shadeIndex));
  });
  window.__salvationShades1 = boot;
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__salvationStickyAtc1) { window.__salvationStickyAtc1.boot(); return; }
  const entries = new Map(), selector = '[data-salvation-sticky]';
  const rootOfBar = target => target instanceof Element ? target.closest('[data-satc-bar]') : null;
  let scheduled = false;
  const enabledDevice = entry => entry.root.dataset.enabled === 'true' && (innerWidth < 750 ? entry.root.dataset.mobile : entry.root.dataset.desktop) === 'true';
  const reduced = entry => entry.root.dataset.motion !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
  function sourceFor(root) {
    let candidates = [];
    if (root.dataset.sourceSelector.trim()) { try { candidates = Array.from(document.querySelectorAll(root.dataset.sourceSelector)); } catch { return null; } }
    else candidates = Array.from(document.querySelectorAll('[data-salvation-root]'));
    candidates = candidates.filter(node => node !== root && node.querySelector('[data-atc]') && (!root.dataset.productId || node.dataset.productId === root.dataset.productId));
    return candidates.filter(node => node.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING).pop() || candidates[0] || null;
  }
  function overlayOpen() {
    return Array.from(document.querySelectorAll('dialog[open],cart-drawer.active,cart-drawer[open],#CartDrawer.active,[data-cart-drawer].is-open,.cart-drawer.is-open,.menu-drawer-container[open]')).some(node => getComputedStyle(node).display !== 'none' && getComputedStyle(node).visibility !== 'hidden');
  }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function release(entry) {
    if (entry.source?.dataset.satcLinked === entry.root.dataset.owner) delete entry.source.dataset.satcLinked;
    entry.sourceObserver?.disconnect(); entry.sourceResize?.disconnect(); entry.source = null;
  }
  function connect(entry) {
    const source = sourceFor(entry.root);
    if (source === entry.source) return;
    release(entry); entry.source = source;
    if (source) {
      entry.sourceObserver = new MutationObserver(schedule);
      entry.sourceObserver.observe(source, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled','hidden','aria-busy','data-selected','selected','data-gallery-index'] });
      if ('ResizeObserver' in window) { entry.sourceResize = new ResizeObserver(schedule); entry.sourceResize.observe(source); }
    }
    const editor = entry.root.querySelector('[data-sticky-editor-status]');
    if (editor) text(editor, source ? 'Connected to your Salvation product section. Select this section to preview the sticky bar. It appears after the whole product section on the storefront.' : 'No matching Salvation product section found. Add this section after the product section, or check the product and source selector settings.');
  }
  function syncContent(entry) {
    const { source, bar, root } = entry;
    const button = source?.querySelector('[data-atc]');
    if (!button) return;
    const active = source.querySelector('[data-offer][data-selected="true"]') || source.querySelector('[data-offer]:has(.svb__offer-heading>input:checked)');
    const picks = Array.from(active?.querySelectorAll('[data-variant-picker]') || []).map(select => select.selectedOptions[0]).filter(Boolean);
    const quantity = picks.length || Number(active?.dataset.quantity || 1);
    const bundleTitle = active?.querySelector('.svb__offer-copy strong')?.textContent.trim() || `${quantity} ${quantity === 1 ? root.dataset.itemSingular : root.dataset.itemPlural}`;
    const variants = new Map();
    for (const pick of picks) { const value = pick.textContent.trim(); variants.set(value, (variants.get(value) || 0) + 1); }
    const variantText = Array.from(variants, ([value, count]) => `${value}${count > 1 ? ` ×${count}` : ''}`).join(' · ');
    const summary = [bundleTitle, root.dataset.variants === 'true' ? variantText : ''].filter(Boolean).join(' · ');
    const summaryNode = bar.querySelector('[data-sticky-selection]');
    text(summaryNode, summary); summaryNode.title = summary;
    const price = active?.querySelector('[data-offer-price]')?.textContent.trim() || source.querySelector('[data-atc-price],[data-main-price]')?.textContent.trim() || '';
    bar.querySelectorAll('[data-sticky-price]').forEach(node => text(node, price));
    const compare = active?.querySelector('[data-offer-compare]') || source.querySelector('[data-main-compare]');
    const before = root.dataset.compare === 'true' && compare && !compare.hidden ? compare.textContent.trim() : '';
    bar.querySelectorAll('[data-sticky-compare]').forEach(node => { text(node, before); node.hidden = !before; });
    const label = source.querySelector('[data-atc-label]')?.textContent.trim() || '';
    const busy = button.getAttribute('aria-busy') === 'true' || Boolean(source.dataset.adding && label === source.dataset.adding);
    bar.dataset.busy = String(busy);
    const proxy = bar.querySelector('[data-sticky-submit]');
    proxy.disabled = button.disabled || entry.forwarding;
    proxy.setAttribute('aria-busy', String(busy));
    text(bar.querySelector('[data-sticky-button-label]'), busy ? root.dataset.loadingLabel : button.disabled ? root.dataset.soldOutLabel : root.dataset.buttonLabel);
    if (root.dataset.fixedImage !== 'true') {
      const imageId = picks[0]?.dataset.imageId;
      const variantSlide = imageId ? Array.from(source.querySelectorAll('[data-slide]')).find(slide => slide.dataset.imageId === imageId) : null;
      const image = root.dataset.imageSource === 'bundle' ? active?.querySelector('.svb__offer-image img') : variantSlide?.querySelector('img') || source.querySelector('[data-slide]:not([hidden]) img');
      const src = image?.currentSrc || image?.src;
      const target = bar.querySelector('.sstk__image img');
      if (src && target) {
        if (target.getAttribute('src') !== src) { target.removeAttribute('srcset'); target.src = src; }
        target.alt = image.alt || bar.querySelector('.sstk__title').textContent;
        target.hidden = false; bar.querySelector('[data-sticky-image-fallback]').hidden = true;
      }
    }
    const originalFeedback = source.querySelector('[data-feedback]'), output = bar.querySelector('[data-sticky-feedback]');
    const message = root.dataset.feedback === 'true' && originalFeedback && !originalFeedback.hidden ? originalFeedback.textContent.trim() : '';
    text(output, message); output.hidden = !message;
  }
  function reserve(entry, visible) {
    const height = visible ? Math.ceil(entry.bar.getBoundingClientRect().height + parseFloat(getComputedStyle(entry.bar).bottom || '0') + 8) : 0;
    const value = `${height}px`;
    if (entry.spacer.style.height !== value) entry.spacer.style.height = value;
  }
  function show(entry, visible) {
    entry.visible = visible;
    clearTimeout(entry.hideTimer);
    if (visible) {
      const fresh = entry.bar.hidden;
      entry.bar.hidden = false; entry.bar.inert = false;
      if (fresh && !reduced(entry)) requestAnimationFrame(() => { if (entry.visible) entry.bar.dataset.shown = 'true'; });
      else entry.bar.dataset.shown = 'true';
    } else {
      entry.bar.dataset.shown = 'false'; entry.bar.inert = true;
      entry.hideTimer = setTimeout(() => { if (!entry.visible) entry.bar.hidden = true; }, reduced(entry) ? 0 : 340);
    }
    reserve(entry, visible);
  }
  function update() {
    scheduled = false;
    const claimed = new Set(), dialog = overlayOpen();
    for (const entry of entries.values()) {
      if (!entry.root.isConnected) continue;
      if (!entry.source?.isConnected) connect(entry);
      const active = enabledDevice(entry), source = entry.source;
      const winner = active && source && !claimed.has(source);
      if (winner) claimed.add(source);
      if (source && winner && entry.root.dataset.replaceExisting === 'true') source.dataset.satcLinked = entry.root.dataset.owner;
      else if (source?.dataset.satcLinked === entry.root.dataset.owner) delete source.dataset.satcLinked;
      const button = source?.querySelector('[data-atc]');
      if (button) syncContent(entry);
      const passed = source && source.getBoundingClientRect().height > 0 && source.getBoundingClientRect().bottom <= -Number(entry.root.dataset.after || 0);
      const preview = entry.preview && entry.root.dataset.designMode === 'true';
      show(entry, Boolean(winner && button && (passed || preview) && !(entry.root.dataset.hideDialog === 'true' && dialog)));
    }
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
  function destroy(entry) {
    release(entry); clearTimeout(entry.hideTimer); entry.barResize?.disconnect(); entry.bar.remove(); entry.spacer.remove(); entries.delete(entry.root.dataset.owner);
  }
  function boot() {
    for (const entry of entries.values()) if (!entry.root.isConnected) destroy(entry);
    document.querySelectorAll(selector).forEach(root => {
      const key = root.dataset.owner, previous = entries.get(key);
      if (previous?.root === root) { connect(previous); return; }
      if (previous) destroy(previous);
      const bar = root.querySelector('[data-satc-bar]');
      if (!bar) return;
      const spacer = document.createElement('div'); spacer.dataset.salvationStickySpacer = key; spacer.setAttribute('aria-hidden', 'true'); spacer.style.cssText = 'height:0;pointer-events:none;visibility:hidden;flex-shrink:0';
      const entry = { root, bar, spacer, source: null, visible: false, forwarding: false, preview: false };
      entries.set(key, entry); document.body.append(bar, spacer);
      if ('ResizeObserver' in window) { entry.barResize = new ResizeObserver(() => { reserve(entry, entry.visible); }); entry.barResize.observe(bar); }
      connect(entry);
    });
    schedule();
  }
  document.addEventListener('click', event => {
    const bar = rootOfBar(event.target), entry = bar && entries.get(bar.dataset.owner);
    if (!entry) return;
    if (event.target.closest('[data-sticky-submit]')) {
      event.preventDefault();
      const button = entry.source?.querySelector('[data-atc]');
      if (!button?.isConnected || button.disabled || entry.forwarding) { schedule(); return; }
      entry.forwarding = true; bar.querySelector('[data-sticky-submit]').disabled = true;
      button.click();
      requestAnimationFrame(() => { entry.forwarding = false; schedule(); });
    }
    if (event.target.closest('[data-sticky-edit]')) {
      event.preventDefault();
      const target = entry.source?.querySelector('[data-offer][data-selected="true"]') || entry.source?.querySelector('.svb__offers') || entry.source;
      if (!target) return;
      window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + scrollY - Number(entry.root.dataset.scrollOffset || 0)), behavior: reduced(entry) ? 'auto' : 'smooth' });
      (target.querySelector('[data-bundle-swatch]:not(:disabled),[data-bundle-option]:not(:disabled)') || target.querySelector('button:not(:disabled),select:not(:disabled),input:not(:disabled)'))?.focus({ preventScroll: true });
      schedule();
    }
  });
  window.addEventListener('scroll', schedule, { passive: true }); window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => { for (const entry of entries.values()) if (entry.root.dataset.owner === String(event.detail?.sectionId)) destroy(entry); schedule(); });
  document.addEventListener('shopify:section:select', event => { const entry = entries.get(String(event.detail?.sectionId)); if (entry) { entry.preview = true; schedule(); } });
  document.addEventListener('shopify:section:deselect', event => { const entry = entries.get(String(event.detail?.sectionId)); if (entry) { entry.preview = false; schedule(); } });
  const structure = new MutationObserver(records => {
    let rebuild = false, changedOverlay = false;
    for (const record of records) {
      if (record.type === 'attributes') { if (record.target.matches('dialog,cart-drawer,#CartDrawer,[data-cart-drawer],.cart-drawer,.menu-drawer-container')) changedOverlay = true; continue; }
      for (const node of [...record.addedNodes, ...record.removedNodes]) if (node instanceof Element && (node.matches(`${selector},[data-salvation-root]`) || node.querySelector(`${selector},[data-salvation-root]`))) rebuild = true;
    }
    if (rebuild) boot(); else if (changedOverlay) schedule();
  });
  structure.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class','open','aria-hidden'] });
  window.__salvationStickyAtc1 = { boot };
  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
})();


  } catch(e) { console.error(e); }
})();
})();
